import React from 'react';
import { resolveProjectType, type ProjectTypeOption } from './PatternBuilder/helpers';

import sockSvg from '../assets/icons/sock.svg?raw';
import hatSvg from '../assets/icons/hat.svg?raw';
import sweaterSvg from '../assets/icons/sweater.svg?raw';
import scarfSvg from '../assets/icons/scarf.svg?raw';
import cowlSvg from '../assets/icons/cowl.svg?raw';
import mittensSvg from '../assets/icons/mittens.svg?raw';
import shawlSvg from '../assets/icons/shawl.svg?raw';
import blanketSvg from '../assets/icons/blanket.svg?raw';
import vestSvg from '../assets/icons/vest.svg?raw';
import teeSvg from '../assets/icons/tee.svg?raw';
import projectSvg from '../assets/icons/project.svg?raw';

interface ProjectTypeIconProps {
  metadata: Record<string, string> | undefined;
  className?: string;
  size?: number;
  /**
   * Optional pattern color (CSS hex `#rrggbb`). When provided, the icon's
   * `--color-primary` and `--color-primary-strong` CSS variables are
   * overridden on the wrapper so the SVG's `fill-primary/30` and
   * `stroke-primary-strong` paint with this color instead of the brand's
   * default purple.
   */
  color?: string;
}

const ICONS: Record<ProjectTypeOption, string> = {
  sock: sockSvg,
  hat: hatSvg,
  sweater: sweaterSvg,
  scarf: scarfSvg,
  cowl: cowlSvg,
  mittens: mittensSvg,
  shawl: shawlSvg,
  blanket: blanketSvg,
  vest: vestSvg,
  tee: teeSvg,
};

/** "#a8c66c" → "168 198 108"  (the space-separated triple Tailwind expects). */
function hexToRgbTriple(hex: string): string | null {
  const m = /^#([0-9a-fA-F]{6})$/.exec(hex);
  if (!m) return null;
  const n = parseInt(m[1], 16);
  return `${(n >> 16) & 0xff} ${(n >> 8) & 0xff} ${n & 0xff}`;
}

export const ProjectTypeIcon: React.FC<ProjectTypeIconProps> = ({
  metadata,
  color,
  className,
  size = 40,
}) => {
  const resolved = resolveProjectType(metadata);
  const svg = (resolved && ICONS[resolved]) ?? projectSvg;

  const style: React.CSSProperties = {
    width: size,
    height: size,
    display: 'inline-block',
    lineHeight: 0,
  };
  if (color) {
    const triple = hexToRgbTriple(color);
    if (triple) {
      const vars = style as React.CSSProperties & Record<string, string>;
      vars['--color-primary'] = triple;
      vars['--color-primary-strong'] = triple;
    }
  }

  return (
    <span
      className={className}
      style={style}
      dangerouslySetInnerHTML={{ __html: svg }}
    />
  );
};
